import { updateProfile } from 'firebase/auth'
import { useAuth } from 'hooks/admin/useAuth'
import { useState } from 'react'
import { useForm } from 'react-hook-form'

interface SignUpFormData {
    email: string
    password: string
    organizationName: string
    contactInfo: string
}

export const SignUp: React.FC = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<SignUpFormData>()
    const { createUser } = useAuth()
    const [errorMessage, setErrorMessage] = useState<string>('')

    const onSubmit = async (data: SignUpFormData) => {
        try {
            // might need to move the createUser to backend to prevent automatic login
            const userCredential = await createUser(data.email, data.password)
            await updateProfile(userCredential.user, {
                displayName: data.organizationName,
            })
        } catch (error: any) {
            console.error(error.message)
            setErrorMessage('Failed to sign up. Please try again.')
        }
    }

    return (
        <div style={{ margin: '1rem' }}>
            <h2>Sign Up</h2>
            <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', flexDirection: 'column', width: '15rem' }}>
                <input type="email" placeholder="Email" {...register('email', { required: true })} />
                {errors.email && <span>Email is required</span>}
                <input type="password" placeholder="Password" {...register('password', { required: true })} />
                {errors.password && <span>Password is required</span>}
                <input type="text" placeholder="Organization Name" {...register('organizationName', { required: true })} />
                {errors.organizationName && <span>Organization Name is required</span>}
                <input type="text" placeholder="Contact Info" {...register('contactInfo')} />
                {errorMessage && <span style={{ color: 'red' }}>{errorMessage}</span>}
                <button type="submit">Sign Up</button>
            </form>
        </div>
    )
}
